import * as React from 'react';

import DemoGuardedButton from './demoGuardedButton';
import EvidenceRestrictedModal from './evidenceRestrictedModal';

import { AiRestrictionContext } from '../../contexts/AiRestrictionContextProvider';
import { EVIDENCE } from '../../../Shared/index';

interface GuardedActivity {
  activity_classification?: { key?: string };
  classification?: { key?: string };
  activity_classification_key?: string;
}

export const isEvidenceActivity = (activity: GuardedActivity) => (
  (activity.activity_classification?.key ?? activity.classification?.key ?? activity.activity_classification_key) === EVIDENCE
);

interface EvidenceGuardedButtonProps {
  children: React.ReactNode;
  onClick: (event: React.MouseEvent<HTMLButtonElement>) => void;
  activities: GuardedActivity[];
  className?: string;
  withDemoGuard?: boolean;
}

const EvidenceGuardedButton: React.FC<EvidenceGuardedButtonProps> = ({
  children,
  onClick,
  activities,
  className = '',
  withDemoGuard = false,
}) => {
  const aiRestrictedGroup = React.useContext(AiRestrictionContext);
  const [showModal, setShowModal] = React.useState(false);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    if (aiRestrictedGroup && activities.some(isEvidenceActivity)) {
      setShowModal(true);
    } else {
      onClick(event);
    }
  };

  const handleCloseModal = () => {
    setShowModal(false);
  };

  const button = withDemoGuard ? (
    <DemoGuardedButton className={className} onClick={handleClick}>
      {children}
    </DemoGuardedButton>
  ) : (
    <button
      className={className}
      onClick={handleClick}
      type="button"
    >
      {children}
    </button>
  );

  return (
    <React.Fragment>
      {button}
      {showModal && <EvidenceRestrictedModal aiRestrictedGroup={aiRestrictedGroup} onClose={handleCloseModal} />}
    </React.Fragment>
  );
};

export default EvidenceGuardedButton;
